import { useMutation } from '@apollo/client'
import { SetTestSessionLab, SetTestSessionLabVariables } from '../../types'
import { SET_TEST_SESSION_LAB } from './operations'

export const useSetTestSessionLab = () =>
  useMutation<SetTestSessionLab, SetTestSessionLabVariables>(SET_TEST_SESSION_LAB)
